import React, { useEffect, useState } from "react";
import axios from "axios";
import ReactGA from "react-ga";
import "./App.scss";
import Introduction from "./components/Introduction";
import Questions from "./components/Questions";
import smoothscroll from "smoothscroll-polyfill";
import { Shuffle } from "./utilities/Helpers";
import { getMobileOperatingSystem } from "./utilities/Helpers";

function initializeReactGA() {
  ReactGA.initialize("UA-175813817-1");
  ReactGA.pageview("/homepage");
}

function App() {
  smoothscroll.polyfill();
  const [start, setStart] = useState(false);
  const [system, setSystem] = useState("i");
  const [riddles, setRiddles] = useState([]);

  const API_URL = "https://api.airtable.com/v0/appea5d3L67tz0p9Q/QIXI?api_key=key6CEMdrNrB0tnOU";

  const fetchRiddles = async () => {
    try {
      const res = await axios.get(API_URL);
      const riddlesData = res.data.records.map(record => {
        return {
          id: record.id,
          question: record.fields.question,
          answers: record.fields.answers.split(";"),
          hint: record.fields.hint,
          clues: record.fields.clues.split(";"),
          explanation: record.fields.explanation,
          type: record.fields.type,
        };
      });
      setRiddles(riddlesData);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    initializeReactGA();
    setSystem(getMobileOperatingSystem);
    fetchRiddles();
  }, []);

  const handleGameStart = () => {
    setStart(true);
  };

  const handleRestartGame = () => {
    setStart(false);
    setRiddles(Shuffle(riddles).slice(0, 10));
  };

  return (
    <div className="App" style={{ maxWidth: system === "unknown" && `425px` }}>
      {start && riddles ? (
        <Questions system={system} questions={Shuffle(riddles.slice(0, 10))} restartGame={() => handleRestartGame()} />
      ) : (
        <Introduction startGame={() => handleGameStart()} />
      )}
    </div>
  );
}

export default App;
